import { Avatar } from '@components/avatar.component';
import { CaseCard } from '@components/case_card.component';
import { Icon } from '@components/icon.component';
import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { AttentionCardCaseCardWrapper } from './_attention_card_case_card_wrapper.component';
import type { AttentionCardAppointmentCaseModel } from '@components/attention_card/_attention_card.controller';
import { getAppointmentParticipantsText } from './_get_appointment_participant_text';

interface Props {
	alertive?: boolean;
	case: AttentionCardAppointmentCaseModel;
	description: string;
	analyticAction: string;
	ariaLabel?: string;
}

export function AttentionCardCaseCardAppointment({
	case: $case,
	description,
	alertive,
	analyticAction,
	ariaLabel,
}: Props): JSX.Element {
	const participantsText = getAppointmentParticipantsText($case);

	return (
		<AttentionCardCaseCardWrapper description={description} to={$case.link} ariaLabel={ariaLabel} analyticAction={analyticAction}>
			<CaseCard>
				<CaseCard.Thumbnail>
					<Avatar>
						{$case.participantCount <= 2 ? (
							$case.actingHcp?.profileImageUrl != null ? (
								<Avatar.Image src={$case.actingHcp.profileImageUrl} />
							) : (
								<Avatar.Icon type='avatar' />
							)
						) : (
							<Avatar.Icon type='avatars' />
						)}
					</Avatar>
				</CaseCard.Thumbnail>
				<CaseCard.Title>{participantsText}</CaseCard.Title>
				<CaseCard.Subtitle>{$case.receptionName}</CaseCard.Subtitle>
				<CaseCard.Date>{$case.dateFormatted}</CaseCard.Date>
				<CaseCard.Icon>
					<Icon type={alertive ? 'attentionCardArrow' : 'clock'} />
				</CaseCard.Icon>

				{alertive ? <CaseCard.Footer>{withTranslation('PW.Component.AttentionCard.Appointment.EnterCall')}</CaseCard.Footer> : null}
			</CaseCard>
		</AttentionCardCaseCardWrapper>
	);
}
